import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  assignMembershipRoles,
  DIAM_API_PATH,
  DIAM_TEAM_ID,
  DiamMembershipRoleAssignRequest,
} from '../../diamApi';
import { useApiEssentials } from '../../../../shared/hooks/useApiEssentials';

export function useAssignMembershipRoles(identityId: string | undefined) {
  const { getIdToken, apiUrl } = useApiEssentials(DIAM_API_PATH);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (roles: DiamMembershipRoleAssignRequest[]) => {
      if (!identityId) {
        throw new Error('An identity id is required');
      }

      const idToken = await getIdToken();
      return assignMembershipRoles(apiUrl, idToken, identityId, roles);
    },
    onSettled: () => {
      if (!identityId) {
        return;
      }

      queryClient.invalidateQueries({
        queryKey: ['diam', 'teams', DIAM_TEAM_ID, 'members', identityId],
      });
      queryClient.invalidateQueries({
        queryKey: ['diam', 'identities', 'page'],
      });
      queryClient.invalidateQueries({
        queryKey: ['diam', 'assign-identity-drawer'],
      });
    },
  });
}
